import { ReactNode, useState } from 'react';
import { Image, Platform, View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useRoute } from '@react-navigation/native';
import { Footer } from './Footer';
import {
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/components/Util/reactResponsiveDimensions';
import { isPatientApp, isTherapistApp } from '@/config/constants';
import colors from '@/config/colors';
import { styles } from './styles';

export const MAX_WIDTH = 850;

interface LoginLayoutProps {
  children: ReactNode;
  outerButtons?: ReactNode;
  scrollableHeader?: ReactNode;
}

export const LoginLayout = ({
  children,
  outerButtons,
  scrollableHeader,
}: LoginLayoutProps) => {
  const route = useRoute();
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);
  const extraHeight = useResponsiveHeight(30);

  const showTherapistHeader = isTherapistApp && route.name === 'Login';

  return (
    <View
      style={
        showTherapistHeader
          ? { flex: 1 }
          : { flex: 1, backgroundColor: colors.newUI.therapist.bgBlue10 }
      }
    >
      {!isKeyboardVisible && !showTherapistHeader ? (
        <View style={{ height: 64, marginVertical: 20 }}>
          <Image
            source={require('../../assets/neolexon_Logo_ohneClaim.png')}
            style={{
              flex: 1,
              width: '100%',
              height: '100%',
              resizeMode: 'contain',
            }}
          />
        </View>
      ) : null}
      <KeyboardAwareScrollView
        enableOnAndroid
        extraHeight={extraHeight}
        onKeyboardDidHide={() => setIsKeyboardVisible(false)}
        onKeyboardDidShow={() => setIsKeyboardVisible(true)}
      >
        <View
          style={{ alignItems: 'center', justifyContent: 'center', flex: 1 }}
        >
          {scrollableHeader}
          <View
            style={[
              styles.layoutChildrenContainer,
              {
                padding: isPatientApp ? 40 : useResponsiveWidth(2.5),
              },
            ]}
            role={Platform.OS === 'web' ? 'form' : undefined}
          >
            {children}
          </View>
          {outerButtons ? (
            <View style={{ maxWidth: MAX_WIDTH, width: '100%', flex: 1 }}>
              {outerButtons}
            </View>
          ) : null}
        </View>
      </KeyboardAwareScrollView>
      {!isKeyboardVisible && (
        <View style={{ paddingHorizontal: 24 }}>
          <Footer />
        </View>
      )}
    </View>
  );
};
